import {useQuery} from '@tanstack/react-query';
import {interpolateRoute, request} from 'apstra-ui-common';
import {FC, useContext} from 'react';

import IBAContext from '../IBAContext';
import {allowResponseErrorCode} from '../../allowResponseErrorCode';
import {apiQueryOptions} from '../../apiQueryOptions';
import {Probe, ProbeStage} from '../types';

import PersistedLabel from './PersistedLabel';

type ProbeStageDiskUsageLabelProps = {
  probe: Probe;
  refetchInterval?: number;
  stage: ProbeStage;
};

export const ProbeStageDiskUsageLabel: FC<ProbeStageDiskUsageLabelProps> = ({
  probe,
  refetchInterval = 60000,
  stage
}) => {
  const {blueprintId, routes} = useContext(IBAContext);
  const diskUsageQuery = useQuery({
    ...apiQueryOptions.diskSpaceUsageForStage(blueprintId, probe.id, stage.name),
    queryFn: ({signal}) => allowResponseErrorCode(
      request(
        interpolateRoute(routes.diskSpaceUsageForStage, {blueprintId, probeId: probe.id, stageName: stage.name}),
        {signal}
      ),
      404
    ),
    enabled: stage.enable_metric_logging,
    refetchInterval
  });

  return <PersistedLabel
    duration={stage.retention_duration}
    diskUsage={diskUsageQuery.data as any}
    isLoading={diskUsageQuery.isLoading}
  />;
};
